<template>
	<div class="p-6">
		<h1 class="text-2xl font-semibold text-gray-900 mb-4" v-if="hasH1">
			{{ __("Edit base data") }}
		</h1>

		<div class="flex flex-wrap gap-x-6 gap-y-4">
			<ui-input-group
				class="basis-full md:basis-[calc(50%-0.75rem)]"
				v-model="form.company_name"
				field="company_name"
				label="Company"
				:form="form"
				:required="true"
			></ui-input-group>
			<ui-select-group
				v-model="form.type"
				class="basis-full md:basis-[calc(50%-0.75rem)]"
				field="type"
				type="select"
				label="Type of company"
				:options="$cropOptions.companyTypeOptions"
				:form="form"
				:required="true"
				:disabled="!canEditCompanyType"
			></ui-select-group>

			<ui-input-group
				v-model="form.address.street"
				class="basis-full"
				field="address.street"
				label="Street + house number"
				:form="form"
				:required="true"
				:autoReplace="false"
			></ui-input-group>

			<crop-location-picker
				class="basis-full mt-0"
				v-model="form.address"
				:form="form"
			>
			</crop-location-picker>

			<ui-input-group
				v-if="hasEuVatId"
				class="basis-full md:flex-1"
				v-model="form.eu_vatid"
				field="eu_vatid"
				label="Tax Identifier"
				:form="form"
				:required="false"
			></ui-input-group>

			<ui-select-group
				v-if="hasEuVatId"
				class="basis-full md:basis-[calc(33.333%-1rem)]"
				v-model="form.preferred_language"
				type="select"
				field="preferred_language"
				label="Preferred Language"
				:options="$cropOptions.languageOptions"
				:form="form"
				:required="true"
				@change="triggerReload"
			>
			</ui-select-group>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		hasEuVatId: {
			type: Boolean,
			default: true,
		},
		hasH1: {
			type: Boolean,
			default: true,
		},
		canEditCompanyType: {
			type: Boolean,
			default: false,
		},
	},
	data: function () {
		return {
			companyTypeOptions: this.$cropOptions.companyTypeOptions,
			countryOptions: this.$cropOptions.countryOptions,
		};
	},
	methods: {
		triggerReload() {
			if ("parentIFrame" in window) {
				window.parentIFrame.sendMessage("FULL_RELOAD");
			}
		},
	},
};
</script>
